<script setup>
import { ref } from 'vue'
import AssessmentCarousel from '../components/AssessmentCarousel.vue'
import { useRoute } from 'vue-router';
import { useAssessmentsStore, useAuthStore } from '../stores';

const route = useRoute()
const assessmentsStore = useAssessmentsStore()
const authStore = useAuthStore()
const assessment = ref({})
assessment.value = assessmentsStore.readinessAssessments[route.params.id]
</script>
<template>
    <Suspense>
        <template #fallback>
            Loading
        </template>
        <AssessmentCarousel class="flex flex-col items-center" />
    </Suspense>
</template>